var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_1630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.333374 12.0002C0.333374 16.914 3.28819 21.1354 7.51641 22.9913C7.48266 22.1534 7.51041 21.1475 7.72528 20.2358C7.956 19.2616 9.26934 13.6969 9.26934 13.6969C9.26934 13.6969 8.886 12.9307 8.886 11.7983C8.886 10.0199 9.91669 8.69175 11.2003 8.69175C12.2918 8.69175 12.8192 9.51159 12.8192 10.4933C12.8192 11.5906 12.1193 13.2319 11.7594 14.752C11.4588 16.025 12.3977 17.0632 13.6535 17.0632C15.9271 17.0632 17.4584 14.143 17.4584 10.6831C17.4584 8.05303 15.687 6.08447 12.4651 6.08447C8.82497 6.08447 6.55725 8.79909 6.55725 11.8313C6.55725 12.8768 6.8655 13.6141 7.34831 14.185C7.57031 14.4473 7.60116 14.5527 7.52081 14.8538C7.46325 15.0746 7.33106 15.6062 7.27631 15.8168C7.19644 16.1208 6.95016 16.2294 6.67547 16.1172C4.99884 15.4328 4.218 13.5967 4.218 11.5327C4.218 8.12381 7.09294 4.03631 12.7944 4.03631C17.376 4.03631 20.3915 7.35169 20.3915 10.9105C20.3915 15.618 17.7743 19.1348 13.9165 19.1348C12.621 19.1348 11.4023 18.4345 10.9849 17.6391C10.9849 17.6391 10.2882 20.4039 10.1407 20.9378C9.88622 21.8631 9.38822 22.7878 8.93287 23.5086C10.037 23.835 11.1824 24.0008 12.3338 24.0007C18.9605 24.0007 24.3335 18.6279 24.3335 12.0002C24.3335 5.37272 18.9605 0 12.3338 0C5.70656 0 0.333374 5.37272 0.333374 12.0002Z",
    fill: "#CB1F27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_1630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.22a9dffb116b750f15d5cb45f4336011.svg";
export { ForwardRef as ReactComponent };